export const OPEN_MODAL_CONFIRM = `OPEN_MODAL_CONFIRM`;
export const CLOSE_MODAL_CONFIRM = `CLOSE_MODAL_CONFIRM`;